/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';

	const historyAnime = () => {
		let currentbarHeight = 0;
		const historyBar = (scroll, windowHeight) => {
			const bar = $('.guide-history-bar')
			const targetPosition = bar.offset().top;
			const firstDotPosition = $('.guide-history-dot:first').offset().top;
			const lastDotPosition = $('.guide-history-dot:last').offset().top;
			if (scroll > targetPosition - windowHeight + windowHeight * 0.5) {
				const barHeight = scroll + windowHeight - windowHeight * 0.5 - targetPosition
				if (barHeight <= (lastDotPosition - firstDotPosition)) {
					if (currentbarHeight < barHeight) {						
						bar.css('height', barHeight + 'px');
						currentbarHeight = barHeight;
					}
				}else {
					bar.css('height', lastDotPosition - firstDotPosition + 'px');
					currentbarHeight = lastDotPosition - firstDotPosition;
				}
			}
		}
		const historyDot = (scroll, windowHeight) => {
			$('.guide-history-dot').each(function () {
				const targetPosition = $(this).offset().top;
				if (scroll > targetPosition - windowHeight + windowHeight * 0.5) {
					$(this).addClass(a);
				}
			});
		}
		$(window).scroll(function () {
			const windowHeight = $(window).height();
			const scroll = $(window).scrollTop();			
			historyBar(scroll, windowHeight)
			historyDot(scroll, windowHeight)
		});
		historyBar(scroll, windowHeight)
		historyDot(scroll, windowHeight)

	}
	historyAnime()

})(window.jQuery, window.FUNCTIONS);